import { render, staticRenderFns } from "./ProjectGallery.vue?vue&type=template&id=283bc88f&scoped=true"
import script from "./ProjectGallery.vue?vue&type=script&lang=js"
export * from "./ProjectGallery.vue?vue&type=script&lang=js"
import style0 from "./ProjectGallery.vue?vue&type=style&index=0&id=283bc88f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283bc88f",
  null
  
)

export default component.exports